"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var locale_context_1 = __importDefault(require("./locale.context"));
var react_1 = require("react");
function useLocale() {
    return react_1.useContext(locale_context_1.default);
}
exports.default = useLocale;
//# sourceMappingURL=use-locale.hook.js.map